import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "key"];
import React from 'react';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
export var InsecureIframeErrorMessage = function InsecureIframeErrorMessage() {
  return /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "error",
    title: "Unable to continue",
    actions: [{
      key: 'support',
      href: 'https://support.atlassian.com/',
      text: 'Contact support'
    }].map(function (_ref) {
      var text = _ref.text,
        key = _ref.key,
        restAction = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/React.createElement(SectionMessageAction, _extends({}, restAction, {
        key: key
      }), text);
    })
  }, "We've detected an insecure environment and not able to display the credit card form.");
};
var getIsStorybookEnv = function getIsStorybookEnv() {
  return window.location.pathname.startsWith('/iframe');
};
var getIsSiteEnv = function getIsSiteEnv() {
  return window.location.pathname.startsWith('/examples.html');
};
var getIsCypressEnv = function getIsCypressEnv() {
  return 'Cypress' in window;
};
var getIsDevMode = function getIsDevMode() {
  return window && (getIsStorybookEnv() || getIsSiteEnv() || getIsCypressEnv());
};
var getIsTopFrame = function getIsTopFrame() {
  return self === top;
};
export var isSecureEnvironment = function isSecureEnvironment() {
  return getIsTopFrame() || getIsDevMode();
};
export var FrameBreaker = function FrameBreaker(_ref2) {
  var children = _ref2.children,
    disabled = _ref2.disabled;
  return disabled || isSecureEnvironment() ? children : /*#__PURE__*/React.createElement(InsecureIframeErrorMessage, null);
};